import { memo } from 'react';
import { GameData } from 'react-easyrocket';
import { useTranslation } from 'react-i18next';
import { Button } from 'src/components/Buttons/Button';
import { GameImage } from 'src/components/GameCard/components/GameImage';

interface JackpotWinModalGameProps {
  game?: GameData;
  isGamePage: boolean;
  onClick: () => void;
}

const _JackpotWinModalGame = ({ game, isGamePage, onClick }: JackpotWinModalGameProps) => {
  const { t } = useTranslation();

  if (!game) {
    return;
  }

  return (
    <div className="mt-2.5 mb-9 flex bg-rwm_bg rounded">
      <GameImage game={game as unknown as GameData} className="!w-20 max-w-none rounded-r-none" />
      <div className="max-w-[224px] min-w-[224px] p-3 text-left flex flex-col">
        <p className="line-clamp-2 text-rwm_game_name text-base font-bold leading-4 mb-1">
          {game?.name}
        </p>
        <p className="line-clamp-1 text-[white] text-xs font-medium">{game?.providerName}</p>

        {!isGamePage && (
          <Button
            className="mt-auto"
            mode="button-secondary"
            label={t('general.play')}
            title={t('general.play')}
            onClick={onClick}
          />
        )}
      </div>
    </div>
  );
};

export const JackpotWinModalGame = memo(_JackpotWinModalGame);
